import { createStore, is } from 'effector';
export function status(params) {
  var {
    effect,
    defaultValue = 'initial'
  } = is.effect(params, {
    sid: "cn6w5b"
  }) ? {
    effect: params
  } : params;
  var $status = createStore(defaultValue, {
    name: "$status",
    sid: "ph7d4u"
  });
  if (!is.effect(effect, {
    sid: "-kp39vu"
  })) {
    throw TypeError("status: \"effect\" property is not an effect");
  }
  $status.on(effect, () => 'pending').on(effect.done, () => 'done').on(effect.fail, () => 'fail');
  return $status;
}